export const state = () => ({
  customers: {},
})

const cloneDocuments = (documents = []) =>
  JSON.parse(JSON.stringify(Array.isArray(documents) ? documents : []))

export const mutations = {
  setCustomerDocuments(state, { customerId, documents, nextCursor, hasMore }) {
    state.customers = {
      ...state.customers,
      [customerId]: {
        documents: cloneDocuments(documents),
        nextCursor: nextCursor || null,
        hasMore: hasMore === true,
        loadedAt: Date.now(),
      },
    }
  },
}

export const getters = {
  forCustomer: (state) => (customerId) => {
    const cached = state.customers[customerId]
    if (!cached) return null

    return {
      ...cached,
      documents: cloneDocuments(cached.documents),
    }
  },
}
